import { dateOffset, dateParse, serverDateNow } from '@/lib/utils';

export class ParticipationModel {
    public id: number;
    public activity: Participation.ListItemActivity;
    public team: Participation.ListItemTeam;
    public package: Participation.ListItemPackage;
    public sign_up_start_date: string;
    public sign_up_finish_date: string;
    public start_date: string;
    public finish_date: string;
    public total_days: number;
    public train_level: number;
    public join_time: string;
    /** 第几个报名的 */
    public join_index: number;
    public has_training_plan: boolean;

    public constructor(raw: Participation.ListItem) {
        this.id = raw.id;
        this.activity = raw.activity;
        this.team = raw.team;
        this.package = raw.package;
        this.sign_up_start_date = raw.sign_up_start_date;
        this.sign_up_finish_date = raw.sign_up_finish_date;
        this.start_date = raw.start_date;
        this.finish_date = raw.finish_date;
        this.total_days = raw.total_days;
        this.train_level = raw.train_level;
        this.join_time = raw.join_time;
        this.join_index = raw.join_index;
        this.has_training_plan = raw.has_training_plan;
    }

    /** 是否开始报名 */
    public get startParticipation() {
        const timestamp = serverDateNow().valueOf();
        return timestamp >= dateParse(this.sign_up_start_date).valueOf();
    }
    /** 是否结束报名 */
    public get closeParticipation() {
        const timestamp = serverDateNow().valueOf();
        return timestamp >= dateOffset(dateParse(this.sign_up_finish_date), 1).valueOf();
    }
    /** 是否开始打卡 */
    public get startSignIn() {
        const timestamp = serverDateNow().valueOf();
        return timestamp >= dateParse(this.start_date).valueOf();
    }
    /** 是否结束打卡 */
    public get closeSignIn() {
        const timestamp = serverDateNow().valueOf();
        return timestamp >= dateOffset(dateParse(this.finish_date), 1).valueOf();
    }
    /** 标签文本 */
    public get tag() {
        if (!this.startParticipation) {
            return '未开始';
        } else if (!this.closeParticipation && !this.startSignIn) {
            return '报名中';
        } else if (this.startSignIn && !this.closeSignIn) {
            return '进行中';
        } else if (this.closeSignIn) {
            return '已结束';
        }
    }
    /** 是否完赛 */
    public get isFinish() {
        return this.total_days >= this.activity.need_sign_in_days;
    }
}
